const tutorTerms: Record<string, string> = {
    'репетитор': 'исполнитель', 'репетитора': 'исполнителя',
    'репетитору': 'исполнителю', 'репетитором': 'исполнителем',
    'репетиторе': 'исполнителе', 'репетиторы': 'исполнители',
    'репетиторов': 'исполнителей', 'репетиторам': 'исполнителям',
    'репетиторами': 'исполнителями', 'репетиторах': 'исполнителях',
};

// Legacy catalog labels are presentation data; feature keys stay unchanged.
export const formatFeatureText = (text: string) => text.replace(/репетитор[а-я]*/gi, word => {
    const replacement = tutorTerms[word.toLowerCase()];
    if (!replacement) return word;
    return word[0] === word[0].toUpperCase()
        ? replacement[0].toUpperCase() + replacement.slice(1)
        : replacement;
}).replace(/штрафов и премий/g, 'корректировок начислений')
  .replace(/Штрафы и премии/g, 'Корректировки начислений');
